export default {
  lang: {
    confirm: {
      title: 'คุณยืนยันว่าต้องการลบหรือไม่? จะไม่สามารถกู้คืนได้หลังจากลบ',
      okText: 'ลบ',
      cancelText: 'การยกเลิก',
    },
  },
};
